import SalesTraining from './SalesTraining';

export default SalesTraining;
